"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Implements the [Full Jitter algorithm](
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/)
 * and also allows for specifying a fixed wait added to the full jitter backoff
 * (which can be zero).
 */

var FullJitterBackoff = /*#__PURE__*/function () {
  function FullJitterBackoff(fixedWaitMs, shortBackoffMs, longBackoffMs) {
    _classCallCheck(this, FullJitterBackoff);

    this.fixedWaitMs = fixedWaitMs;
    this.shortBackoffMs = shortBackoffMs;
    this.longBackoffMs = longBackoffMs;
    this.currentRetry = 0;

    if (this.fixedWaitMs < 0) {
      this.fixedWaitMs = 0;
    }

    if (this.shortBackoffMs < 0) {
      this.shortBackoffMs = 0;
    }

    if (this.longBackoffMs < 0) {
      this.longBackoffMs = 0;
    }

    this.reset();
  }

  _createClass(FullJitterBackoff, [{
    key: "reset",
    value: function reset() {
      this.currentRetry = 0;
    }
  }, {
    key: "nextBackoffAmountMs",
    value: function nextBackoffAmountMs() {
      var fullJitterMs = Math.random() * Math.min(this.longBackoffMs, this.shortBackoffMs * Math.pow(2.0, this.currentRetry)) + this.fixedWaitMs;
      this.currentRetry += 1;
      return fullJitterMs;
    }
  }]);

  return FullJitterBackoff;
}();

exports.default = FullJitterBackoff;